import { useMutation } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { apiClient } from 'src/services/api/client';

const PATH = 'api/landlord/onboard/update-company-profile';

type Request = {
  companyName: string;
}

export const useUpdateCompany = () => {
    return useMutation<void, IStandardErrorResponse, Request>(
        async (payload) => {
            await apiClient(PATH, {
                method: 'patch',
                json: {
                    profile: {
                        company_name: payload.companyName,
                    }
                },
            });
        }
    );
};